var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWave = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 28,
  fill: "none",
  preserveAspectRatio: "none",
  viewBox: "0 4 14 28"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  d: "M1 19.5 4.857 16v4l4.286-4v4L13 16.5"
})));
export { SvgWave as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNCIgaGVpZ2h0PSIyOCIgZmlsbD0ibm9uZSIgcHJlc2VydmVBc3BlY3RSYXRpbz0ibm9uZSIgdmlld0JveD0iMCA0IDE0IDI4Ij4KICA8cGF0aCBzdHJva2U9ImN1cnJlbnRDb2xvciIgZD0iTTEgMTkuNSA0Ljg1NzE0IDE2djRsNC4yODU3Mi00djRMMTMgMTYuNSIvPgo8L3N2Zz4=";